export var MercuryRetailer;
(function (MercuryRetailer) {
    MercuryRetailer["WALMART"] = "wmt";
    MercuryRetailer["KROGER"] = "kro";
    MercuryRetailer["AMAZON"] = "amzn";
    MercuryRetailer["TARGET"] = "tgt";
    MercuryRetailer["DRIZLY"] = "drz";
    MercuryRetailer["RESERVE"] = "res";
    MercuryRetailer["INSTACART"] = "instacart";
    MercuryRetailer["WHOLEFOODS"] = "wholefoods";
})(MercuryRetailer || (MercuryRetailer = {}));
